import { render, staticRenderFns } from "./StorageItem.vue?vue&type=template&id=f600877c"
import script from "./StorageItem.vue?vue&type=script&lang=js"
export * from "./StorageItem.vue?vue&type=script&lang=js"
import style0 from "./StorageItem.vue?vue&type=style&index=0&id=f600877c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports